import { render, staticRenderFns } from "./CardBasicColumns.vue?vue&type=template&id=7d86c5cb&"
import script from "./CardBasicColumns.vue?vue&type=script&lang=js&"
export * from "./CardBasicColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports